import "react";
import { Button, ButtonGroup, Icon } from "@therms/atalaya";
import { IoCamera } from "react-icons/io5";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdAudioFile, MdImage, MdOutlineAttachFile } from "react-icons/md";
import { BiMoviePlay } from "react-icons/bi";
//#region src/modules/Files/components/FileTypeButtons/index.tsx
var FileTypeButtons = ({ disabled, hideIcons, hideLabels, noAudio, noCapture, noFile, noImage, noVideo, onFileTypeClick }) => {
	return /* @__PURE__ */ jsxs(ButtonGroup, {
		disabled,
		fullWidth: true,
		children: [
			!noFile && /* @__PURE__ */ jsxs(Button, {
				className: "sm:space-x-xs flex flex-col text-sm sm:flex-row",
				onClick: () => onFileTypeClick("file"),
				children: [!hideIcons && /* @__PURE__ */ jsx(Icon, {
					Icon: MdOutlineAttachFile,
					size: "sm"
				}), !hideLabels && /* @__PURE__ */ jsx("span", { children: "File" })]
			}),
			!noImage && /* @__PURE__ */ jsxs(Button, {
				className: "sm:space-x-xs flex flex-col text-sm sm:flex-row",
				onClick: () => onFileTypeClick("image"),
				children: [!hideIcons && /* @__PURE__ */ jsx(Icon, {
					Icon: MdImage,
					size: "sm"
				}), !hideLabels && /* @__PURE__ */ jsx("span", { children: "Image" })]
			}),
			!noVideo && /* @__PURE__ */ jsxs(Button, {
				className: "sm:space-x-xs flex flex-col text-sm sm:flex-row",
				onClick: () => onFileTypeClick("video"),
				children: [!hideIcons && /* @__PURE__ */ jsx(Icon, {
					Icon: BiMoviePlay,
					size: "sm"
				}), !hideLabels && /* @__PURE__ */ jsx("span", { children: "Video" })]
			}),
			!noAudio && /* @__PURE__ */ jsxs(Button, {
				className: "sm:space-x-xs flex flex-col text-sm sm:flex-row",
				onClick: () => onFileTypeClick("audio"),
				children: [!hideIcons && /* @__PURE__ */ jsx(Icon, {
					Icon: MdAudioFile,
					size: "sm"
				}), !hideLabels && /* @__PURE__ */ jsx("span", { children: "Audio" })]
			}),
			!noCapture && /* @__PURE__ */ jsxs(Button, {
				className: "sm:space-x-xs flex flex-col text-sm sm:flex-row",
				onClick: () => onFileTypeClick("capture"),
				children: [!hideIcons && /* @__PURE__ */ jsx(Icon, {
					Icon: IoCamera,
					size: "sm"
				}), !hideLabels && /* @__PURE__ */ jsx("span", { children: "Capture" })]
			})
		]
	});
};
//#endregion
export { FileTypeButtons };

//# sourceMappingURL=index.js.map